import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AppLoader from "../components/AppLoader";

/* Entry point for denzo-admin's "Job Orders" menu link: /init/<admin token>. */
export default function Initialize() {
  const { token } = useParams();
  const { loginWithAdminToken } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    // StrictMode runs effects twice in development; one exchange is enough.
    if (started.current) return;
    started.current = true;

    loginWithAdminToken(token)
      .then(() => navigate("/", { replace: true }))
      .catch((err) => navigate(`/login?reason=${encodeURIComponent(err.message)}`, { replace: true }));
  }, [token, loginWithAdminToken, navigate]);

  return <AppLoader />;
}
